import {
  DEPARTMENT_FILTER_CHANGED,
  OFFICE_FILTER_CHANGED,
  REHYDRATED,
  fetchDepartmentsActionCreator,
  fetchJobsActionCreator,
  fetchOfficesActionCreator,
} from '../actions';
import {
  getContentApiUrl, getGreenhouseTray,
} from '../selectors';
import fetchJson from './fetchJson';

const dispatchFetchDepartments = store => {
  const state = store.getState();
  const apiUrl = getContentApiUrl(state);

  store.dispatch(fetchDepartmentsActionCreator(
    fetchJson(
      'departments',
      [apiUrl, 'boards', 'theiconic', 'departments'].join('/'),
    ),
  ));
};

const dispatchFetchOffices = store => {
  const state = store.getState();
  const apiUrl = getContentApiUrl(state);
  store.dispatch(fetchOfficesActionCreator(
    fetchJson(
      'offices',
      [apiUrl, 'boards', 'theiconic', 'offices'].join('/'),
    ),
  ));
};

const dispatchFetchJobs = store => {
  const state = store.getState();
  const apiUrl = getContentApiUrl(state);
  store.dispatch(fetchJobsActionCreator(
    fetchJson(
      'jobs',
      [apiUrl, 'boards', 'theiconic', 'jobs'].join('/'),
      {
        ...state.greenhouse.filters,
      },
    ),
  ));
};

export default store => next => action => {
  const ret = next(action);

  switch (action.type) {
    case REHYDRATED:
      if (getGreenhouseTray(store.getState())) {
        dispatchFetchDepartments(store);
        dispatchFetchOffices(store);
        dispatchFetchJobs(store);
      }
      break;
    case DEPARTMENT_FILTER_CHANGED:
    case OFFICE_FILTER_CHANGED:
      dispatchFetchJobs(store);
      break;
    // no default
  }
  return ret;
};
